import { Col, Tag } from "antd";
import { NhanVienResponse } from "../../models/nhanvien/NhanVien";
import { defaultAvatarImg } from "../../constants";
import { dateCommon } from "../../helpers/common";

const NhanVienHopDongBox = ({ nhanVien }: { nhanVien: NhanVienResponse }) => {
    return (
        <div className="card card-body">
            <div className="form-group row">
                <Col span="6">
                    <div className="text-center mb-2">
                        <img
                            className="profile-user-img img-fluid img-circle"
                            src={
                                nhanVien?.avatar == null || nhanVien?.avatar === ""
                                    ? defaultAvatarImg
                                    : `/${nhanVien?.avatar.replace(/\\/g, "/")}`
                            }
                            alt="User profile picture"
                        />
                    </div>
                    <div className="text-center"><label>{nhanVien?.ma?.toUpperCase()}</label></div>
                </Col>
                <Col span="10">
                    <div className="mb-2">
                        <div>Tên nhân viên</div>
                        <label>{nhanVien?.hoTen?.toUpperCase()}</label>
                    </div>
                    <div className="mb-2">
                        <div>Email</div>
                        <label>{nhanVien?.email}</label>
                    </div>
                    <div>
                        <div>Phòng ban</div>
                        <label>{nhanVien?.tenDonVi}</label>
                    </div>
                </Col>
                <Col sm="8">
                    <div className="mb-2">
                        <div>Giới tính</div>
                        {nhanVien?.gioiTinh ? (
                            <Tag color="pink">
                                <strong>Nữ</strong>
                            </Tag>
                        ) : (
                            <Tag color="blue">
                                <strong>Nam</strong>
                            </Tag>
                        )}
                    </div>
                    <div className="mb-2">
                        <div>Ngày sinh</div>
                        <label>{dateCommon.formatDate(nhanVien?.ngaySinh)}</label>
                    </div>
                    <div>
                        <div>Chức vụ</div>
                        <label>{nhanVien?.tenChucVu}</label>
                    </div>
                </Col>
            </div>
        </div>
    )
}

export default NhanVienHopDongBox